import { IAnomaliesGetResponse } from "@edgetier/watchtower-types";
import { InfiniteData } from "react-query";

/**
 * Update the react query cache with the new anomaly display name.
 * @param anomalyId   The ID of the anomaly being updated.
 * @param displayName The new display name.
 * @param anomalies   The anomalies in the cache.
 * @returns A react-query infinite data object containing the updated anomalies.
 */
export const updateAnomaliesCache = (anomalyId: string, displayName: string) => (
    anomalies: InfiniteData<IAnomaliesGetResponse> | undefined
) => {
    if (typeof anomalies === "undefined") {
        return undefined;
    }

    return {
        ...anomalies,
        pages: anomalies.pages.map((page) => {
            return {
                ...page,
                items: page.items.map((anomaly) =>
                    anomaly.anomalyId === anomalyId ? { ...anomaly, displayName } : anomaly
                ),
            };
        }),
    };
};
